const postos = Object.freeze({
  PONTA: 'p',
  FORA_PONTA: 'fp',
  INTERMEDIARIO: 'int',
  NA: 'na',
})

export default postos
